import { mapEntityProperties } from '@/utils/mapEntityProperties'
import type { BranchMinimumCartSystemAdminDto } from '@/backend/market'
import { BranchMinimumCartSystemMiniEntity } from '../../domain/entities/BranchMinimumCartSystemMiniEntity'

export class BranchMinimumCartSystemMiniModel extends BranchMinimumCartSystemMiniEntity {
  constructor(dataDto: BranchMinimumCartSystemAdminDto) {
    super()
    mapEntityProperties<BranchMinimumCartSystemMiniModel>(this, dataDto)
  }
}
